module.exports = __webpack_public_path__ + "img/smoke12.c034631c.png";